module.exports = __webpack_public_path__ + "fe26d4de363ae752f56019c50ca4c6ad.mp3";